import { render } from "./ChargersModel.vue?vue&type=template&id=567d03ad&scoped=true"
import script from "./ChargersModel.vue?vue&type=script&lang=js"
export * from "./ChargersModel.vue?vue&type=script&lang=js"

import "./ChargersModel.vue?vue&type=style&index=0&id=567d03ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567d03ad"]])

export default __exports__